module.exports = __webpack_public_path__ + "media/images/FindInVideo-ab283821ff98fe002ff606e9bba18c59.png";